const colors = {
  LIGHT: {
    MAIN: {
      PRIMARY: '#22222A',
      SECONDARY: '',
      SUCCESS: '#14C458',
      ERROR: '#F73E55',
      WARNING: '#FFD500',
      INFO: '#0184F7',
      WICADU: '#056CF2',
      GRADIENT: {
        AI: {
          START: '#00ffff',
          MIDDLE: '#8f00ff',
          END: '#0036ff',
        },
        INTG: {
          START: '#022554',
          MIDDLE: '#013C88',
          END: '#022554',
        }
      }
    },
    NEUTRAL: {
      BACKGROUND: '#FFFFFF',
      CARD: '#F3F3F3',
      SIDE: '#F8F8FA',
      SELECTED: '#E0E0E0',
      TRANSPARENT: 'transparent',
      WHITE: '#ffffff'
    },
    FONT: {
      TITLE: '#22222A',
      DESCRIPTION: '#8A8A8A',
      HELPER: '#6B6B6C',
      CONTRAST: '#ffffff',
    },
  },
  DARK: {
    MAIN: {},
    NEUTRAL: {},
    FONT: {},
  },
}

export default colors